import { DialogContent, List } from '@mui/material'
import styled from 'styled-components'

export const SessionsButton = styled.div`
  display: flex;
  color: #f9f2ff !important;
  justify-content: space-between !important;
  align-items: center;
  border-radius: 10px !important;
  border: 2px solid #f9f2ff !important;
  padding: 9px 15px !important;
  width: 100% !important;
  margin: 10px 0px !important;
  font-size: 14px !important;
  letter-spacing: -0.1px !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  overflow: hidden !important;
`
export const SessionNumberContent = styled(DialogContent)`
  font-family: 'Outfit' !important;
  padding: 0px !important;
  min-width: 250px !important;
`
export const DropDownPricePrimary = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: start;
  gap: 5px;
  > .pricing {
    font-weight: 700;
  }
`

export const PaywallDropDownList = styled(List)`
  height: 250px !important;
`
export const PaywallPlanCardInput = styled.div`
  border: 2px solid white;
  border-radius: 10px;
  overflow: hidden;
  text-align: start;
  padding: 9px 15px;
  color: white !important;
  > label: {
    font-size: 14px;
  }
  > input {
    color: white !important;
    background: transparent;
    &:focus {
      outline: none;
    }
  }
`
